import { useMemo } from 'react';

import { useLoggedInEmployeeProfile } from '~/components/Auth';
import { useSelectedEmployeeId } from '~/hooks/employee/useSelectedEmployeeId';
import { getProfilePictureUrl } from '~/utils/helper';

export type EmployeeInfo = {
  firstName: string;
  lastName: string;
  profilePic: string;
};

type UseLeftSideMenuOutput = {
  employeeInfo?: EmployeeInfo;
};

export const useLeftSideMenu = (): UseLeftSideMenuOutput => {
  const myEmployeeInfo = useLoggedInEmployeeProfile();
  const {
    selectedEmployeeId,
    selectedEmployeeDetails: { employeeData: selectedEmployeeData },
  } = useSelectedEmployeeId();

  const employeeInfo = useMemo((): EmployeeInfo | undefined => {
    if (myEmployeeInfo.id === selectedEmployeeId) {
      return {
        firstName: myEmployeeInfo.firstName,
        lastName: myEmployeeInfo.lastName,
        profilePic: myEmployeeInfo.profilePic,
      };
    }

    if (!!selectedEmployeeData) {
      return {
        firstName: selectedEmployeeData.firstName,
        lastName: selectedEmployeeData.lastName,
        profilePic: getProfilePictureUrl(selectedEmployeeData.profilePictureId),
      };
    }

    return undefined;
  }, [myEmployeeInfo, selectedEmployeeId, selectedEmployeeData]);

  return {
    employeeInfo,
  };
};
